import changeCountryHandler from './changeCountryHandler';

const toggleContactCheckbox = () => {
  const loadHandler = () => {
    const countrySelects = document.querySelectorAll('.js-custom-form [type="country"]');
    if (countrySelects) {
      countrySelects.forEach((countrySelect) => {
        countrySelect.addEventListener('change', changeCountryHandler);
        countrySelect.dispatchEvent(new CustomEvent('change'));
      });
    }
  };

  if (document.readyState === 'loading') {
    // loading hasn't finished yet so it is ok to listen for domcontentloaded
    document.addEventListener('DOMContentLoaded', loadHandler);
  } else {
    loadHandler();
  }
};

export default toggleContactCheckbox;
